// ══════════════ CANICULE (bandeau vigilance, rappels hydratation, onglet dédié) + ALERTE MALAISE ══════════════
// Extrait de GerantClientUI.jsx (refacto étape E — briques terrain, dernière du groupe, 07/07/2026).
// Les 4 composants sont utilisés ensemble par GerantUI et StaffUI (AlerteSanteButton partagé,
// CaniBandeau/CaniHydrationBanner/CaniTab dans l'onglet pointage/canicule terrain).
// Feuilles indépendantes : aucune référence croisée entre elles, ni vers un composant
// interne encore non extrait de GerantClientUI.
// Attention : CaniHydrationBanner et CaniTab utilisent Date.now() natif, PAS la fonction
// utilitaire now() de utils.js (seul AlerteSanteButton en a réellement besoin).
import React, { useState, useEffect } from 'react';
import { today, now } from "../utils.js";
import { SUPA_URL, SUPA_KEY } from "../constants.js";
import { useGeo } from "./Pointage.jsx";
import { supaGet, supaSet, supaAuthHeader } from "../supabase.js";
import { M } from "./M.jsx";

function AlerteSanteButton({sid,nom,role,liftForNav}){
  const{req}=useGeo();
  const[open,setOpen]=useState(false);
  const[sending,setSending]=useState(false);
  const[sent,setSent]=useState(false);
  const[err,setErr]=useState(null);
  const envoyer=async()=>{
    if(sending)return;
    setSending(true);setErr(null);
    const alerte={id:'al'+Date.now(),sid,nom,role:role||'',ts:now(),lat:null,lng:null,statut:'envoyee'};
    // 1. Sauvegarde immédiate de l'alerte (traçabilité DUERP), jamais bloquée par la suite
    try{
      const base=await supaGet('alertesSante7')||[];
      await supaSet('alertesSante7',[...base,alerte]);
    }catch(e){console.error('[AlerteSante] Sauvegarde alerte échouée',e.message);}
    // 2. SMS immédiat vers la direction — fire-and-forget côté UI, sans attendre la géoloc
    try{
      const r=await fetch(`${SUPA_URL}/functions/v1/send-sms-alerte`,{
        method:'POST',
        headers:{'apikey':SUPA_KEY,'Authorization':`Bearer ${supaAuthHeader()}`,'Content-Type':'application/json'},
        body:JSON.stringify({nom,role:role||'',message:'un malaise / une situation de détresse'})
      });
      if(!r.ok){const t=await r.text();throw new Error(`HTTP ${r.status} ${t}`);}
    }catch(e){console.error('[AlerteSante] Envoi SMS échoué',e.message);setErr('Le SMS a peut-être échoué, mais ton alerte est bien enregistrée dans l\'app.');}
    setSending(false);setSent(true);
    // 3. Géoloc en arrière-plan (best-effort) : complète l'alerte si dispo, sans jamais bloquer l'envoi
    req((g)=>{
      if(!g)return;
      supaGet('alertesSante7').then(base=>{
        const upd=(base||[]).map(a=>a.id===alerte.id?{...a,lat:g.lat,lng:g.lng}:a);
        return supaSet('alertesSante7',upd);
      }).catch(()=>{});
    });
  };
  return(<>
    <div style={{position:'fixed',bottom:liftForNav?80:24,left:24,zIndex:60}}>
      <button onClick={()=>{setOpen(true);setSent(false);setErr(null);}} className="btn" style={{background:'var(--dg)',color:'white',boxShadow:'0 4px 14px rgba(232,69,69,.5)',padding:'12px 18px',fontSize:14,fontWeight:700}}>🥵 Je ne me sens pas bien</button>
    </div>
    {open&&<M onC={()=>setOpen(false)} title="🆘 Alerte malaise / détresse" col="var(--dg)" ch={
      <div style={{display:'flex',flexDirection:'column',gap:14}}>
        {!sent?(<>
          <div style={{fontSize:13,lineHeight:1.6}}>Un SMS sera envoyé <strong>immédiatement</strong> à la direction (Claire et Franck) avec ton nom et l'heure. Si c'est une urgence vitale, appelle aussi directement le <a href="tel:15" style={{color:'var(--dg)',fontWeight:700}}>15</a> (SAMU).</div>
          <button onClick={envoyer} disabled={sending} className="btn" style={{background:'var(--dg)',color:'white',padding:'14px',fontSize:15,fontWeight:700}}>{sending?'⏳ Envoi en cours…':'🆘 Envoyer l\'alerte maintenant'}</button>
        </>):(
          <div style={{textAlign:'center',padding:'10px 0'}}>
            <div style={{fontSize:32,marginBottom:8}}>✅</div>
            <div style={{fontWeight:700,marginBottom:4}}>Alerte envoyée</div>
            <div style={{fontSize:12,color:'var(--si)'}}>Claire et Franck ont été prévenus. Mets-toi à l'ombre, bois de l'eau, repose-toi. Appelle le 15 si ça ne s'améliore pas.</div>
            {err&&<div style={{fontSize:11,color:'var(--or)',marginTop:8,fontStyle:'italic'}}>{err}</div>}
          </div>
        )}
      </div>
    }/>}
  </>);
}

function CaniBandeau(){
  const[data,setData]=useState(null);
  const[dismissed,setDismissed]=useState(false);
  useEffect(()=>{
    supaGet('canicule7').then(d=>{if(d&&d.niveau&&d.niveau!=='vert')setData(d);}).catch(()=>{});
    // Recharger toutes les 5 minutes
    const id=setInterval(()=>supaGet('canicule7').then(d=>{if(d&&d.niveau&&d.niveau!=='vert')setData(d);else setData(null);}).catch(()=>{}),300000);
    return()=>clearInterval(id);
  },[]);
  if(!data||dismissed)return null;
  const STYLES={
    jaune:{color:'#f57f17',bg:'#fffde7',border:'#f9a825',emoji:'🟡'},
    orange:{color:'#e65100',bg:'#fff3e0',border:'#ff6d00',emoji:'🟠'},
    rouge:{color:'#b71c1c',bg:'#ffebee',border:'#d32f2f',emoji:'🔴'},
  };
  const s=STYLES[data.niveau]||STYLES.jaune;
  return(<div style={{background:s.bg,border:`2px solid ${s.border}`,borderRadius:12,padding:'13px 16px',marginBottom:14}}>
    <div style={{display:'flex',alignItems:'flex-start',gap:10,justifyContent:'space-between'}}>
      <div style={{display:'flex',gap:10,alignItems:'flex-start',flex:1}}>
        <div style={{fontSize:24,flexShrink:0}}>{s.emoji}</div>
        <div>
          <div style={{fontWeight:700,fontSize:14,color:s.color,marginBottom:3}}>
            Vigilance canicule — niveau {data.niveau}
          </div>
          {data.message&&<div style={{fontSize:13,color:s.color,lineHeight:1.5}}>{data.message}</div>}
          <div style={{fontSize:11,color:s.color,marginTop:4,opacity:.8}}>
            Consultez l'onglet 🌡️ Canicule pour les conseils et rappels hydratation.
          </div>
        </div>
      </div>
      <button onClick={()=>setDismissed(true)} style={{background:'none',border:'none',cursor:'pointer',color:s.color,fontSize:16,padding:'0 4px',flexShrink:0}}>✕</button>
    </div>
  </div>);
}

function CaniHydrationBanner({tc,sid}){
  const todayS=today();
  const clk=tc.find(c=>c.sid===sid&&c.date===todayS);
  const swTs=clk?.sw?.ts;
  const[nowMs,setNowMs]=useState(Date.now());
  const[dismissed,setDismissed]=useState([]);
  useEffect(()=>{const id=setInterval(()=>setNowMs(Date.now()),60000);return()=>clearInterval(id);},[]);
  if(!swTs)return null;
  const STEPS=[30,60,90,120,150,180,210,240];
  const MSGS={
    30:"💧 30 min de poste — prenez un grand verre d'eau",
    60:"💧 1h de poste — buvez un verre d'eau",
    90:"🌬️ 1h30 de poste — 5 min de pause fraîcheur",
    120:"💧 2h de poste — hydratation + pause recommandée",
    150:"💧 2h30 de poste — n'attendez pas d'avoir soif",
    180:"🛑 3h de poste — pause 10 min au frais (obligatoire)",
    210:"💧 3h30 de poste — buvez un verre d'eau",
    240:"💧 4h de poste — hydratation + étirez-vous 2 min"
  };
  const elapsedMin=Math.floor((nowMs-new Date(swTs).getTime())/60000);
  const activeStep=[...STEPS].reverse().find(s=>s<=elapsedMin&&!dismissed.includes(s));
  if(!activeStep)return null;
  return(<div style={{background:'linear-gradient(135deg,#e8f5ff,#dbeeff)',border:'2px solid #2196F3',borderRadius:12,padding:'13px 15px',marginBottom:14,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
    <div style={{fontSize:26}}>🌡️</div>
    <div style={{flex:1,minWidth:160}}>
      <div style={{fontWeight:700,fontSize:13,color:'#1565C0',marginBottom:2}}>Rappel canicule</div>
      <div style={{fontSize:13}}>{MSGS[activeStep]}</div>
    </div>
    <button onClick={()=>setDismissed(d=>[...d,activeStep])} style={{fontSize:12,padding:'6px 12px',background:'#2196F3',border:'none',borderRadius:8,cursor:'pointer',color:'white',fontWeight:600,flexShrink:0}}>✓ C'est fait</button>
  </div>);
}

function CaniTab({tc,sid}){
  const todayS=today();
  const clk=tc.find(c=>c.sid===sid&&c.date===todayS);
  const swTs=clk?.sw?.ts;
  const[nowMs,setNowMs]=useState(Date.now());
  const[dismissed,setDismissed]=useState([]);
  const[sec,setSec]=useState('rappels');
  useEffect(()=>{const id=setInterval(()=>setNowMs(Date.now()),60000);return()=>clearInterval(id);},[]);
  const REMINDERS=[
    {min:30,icon:'💧',msg:"Buvez un grand verre d'eau (250 ml)"},
    {min:60,icon:'💧',msg:"Pause hydratation — un verre d'eau"},
    {min:90,icon:'🌬️',msg:"5 min de pause à l'ombre — humidifiez la nuque"},
    {min:120,icon:'💧',msg:"Buvez un verre d'eau + pause fraîcheur"},
    {min:150,icon:'💧',msg:"N'attendez pas d'avoir soif — buvez !"},
    {min:180,icon:'🛑',msg:"Pause 10 min au frais — obligatoire"},
    {min:210,icon:'💧',msg:"Buvez un verre d'eau"},
    {min:240,icon:'💧',msg:"Hydratation + étirez-vous 2 minutes"},
  ];
  const elapsedMin=swTs?Math.floor((nowMs-new Date(swTs).getTime())/60000):null;
  const activeReminder=elapsedMin!==null?[...REMINDERS].reverse().find(r=>r.min<=elapsedMin&&!dismissed.includes(r.min)):null;
  const fmtMin=m=>m<60?`${m} min`:m%60===0?`${m/60}h`:`${Math.floor(m/60)}h${String(m%60).padStart(2,'0')}`;
  const nextR=elapsedMin!==null?REMINDERS.find(r=>r.min>elapsedMin):null;
  return(<div>
    <div style={{display:'flex',gap:6,marginBottom:16,flexWrap:'wrap'}}>
      {[['rappels','⏱️ Rappels'],['symptomes','🌡️ Symptômes'],['conseils','✅ Conseils']].map(([k,l])=>(
        <button key={k} onClick={()=>setSec(k)} className={`btn ${sec===k?'bmn':'bgh'} sm`} style={{fontSize:12}}>{l}</button>
      ))}
    </div>
    {sec==='rappels'&&(<div>
      {!swTs?(<div style={{background:'#f8f4e8',border:'1.5px solid #e5c977',borderRadius:12,padding:'18px 20px',textAlign:'center'}}>
        <div style={{fontSize:32,marginBottom:8}}>⏱️</div>
        <div style={{fontWeight:700,marginBottom:4}}>Pas encore pointé aujourd'hui</div>
        <div style={{fontSize:12,color:'var(--si)'}}>Les rappels démarrent dès votre prise de poste.</div>
      </div>):(
        <div>
          {activeReminder&&(<div style={{background:'linear-gradient(135deg,#e8f5ff,#dbeeff)',border:'2px solid #2196F3',borderRadius:14,padding:'18px 20px',marginBottom:16,display:'flex',alignItems:'center',gap:14,flexWrap:'wrap'}}>
            <div style={{fontSize:40}}>{activeReminder.icon}</div>
            <div style={{flex:1,minWidth:160}}>
              <div style={{fontWeight:700,fontSize:16,marginBottom:4,color:'#1565C0'}}>Rappel — {fmtMin(activeReminder.min)} de poste</div>
              <div style={{fontSize:13}}>{activeReminder.msg}</div>
            </div>
            <button onClick={()=>setDismissed(d=>[...d,activeReminder.min])} className="btn bor sm" style={{fontSize:12}}>✓ C'est fait</button>
          </div>)}
          {!activeReminder&&(<div style={{background:'#e8f5e9',border:'1.5px solid var(--mn)',borderRadius:12,padding:'14px 16px',display:'flex',gap:12,alignItems:'center',marginBottom:16}}>
            <div style={{fontSize:24}}>✅</div>
            <div style={{fontSize:13}}>Tous les rappels du moment sont traités.{nextR?` Prochain dans ${fmtMin(nextR.min-elapsedMin)}.`:' Beau travail !'}</div>
          </div>)}
          <div className="card" style={{padding:'14px 16px'}}>
            <div className="D" style={{fontSize:13,marginBottom:12}}>Programme hydratation</div>
            {REMINDERS.map(r=>{
              const done=dismissed.includes(r.min);
              const past=elapsedMin>=r.min;
              const active=past&&!done;
              return(<div key={r.min} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'1px solid var(--bg)',opacity:!past?0.4:1}}>
                <div style={{width:30,height:30,borderRadius:'50%',background:done?'var(--mn)':active?'#2196F3':'var(--bg)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:done||active?12:14,color:done||active?'white':'inherit',flexShrink:0}}>{done?'✓':active?'!':r.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600}}>{fmtMin(r.min)} de poste</div>
                  <div style={{fontSize:11,color:'var(--si)'}}>{r.msg}</div>
                </div>
                {active&&<button onClick={()=>setDismissed(d=>[...d,r.min])} style={{fontSize:10,padding:'4px 8px',background:'#e3f2fd',border:'1px solid #2196F3',borderRadius:6,cursor:'pointer',color:'#1565C0',flexShrink:0}}>✓ Fait</button>}
              </div>);
            })}
          </div>
        </div>
      )}
    </div>)}
    {sec==='symptomes'&&(<div style={{display:'flex',flexDirection:'column',gap:12}}>
      <div className="card" style={{padding:'14px 16px',borderLeft:'4px solid #FF9800'}}>
        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
          <div style={{fontSize:26}}>⚠️</div>
          <div>
            <div className="D" style={{fontSize:15}}>Coup de chaud (épuisement)</div>
            <div style={{fontSize:11,color:'var(--si)'}}>Signe d'alerte — repos immédiat</div>
          </div>
        </div>
        {["Transpiration excessive","Faiblesse, fatigue soudaine","Maux de tête, vertiges","Nausées, crampes musculaires","Peau pâle et moite"].map(s=>(<div key={s} style={{display:'flex',gap:8,fontSize:13,padding:'4px 0'}}><span style={{color:'#FF9800',fontWeight:700}}>›</span><span>{s}</span></div>))}
        <div style={{background:'#fff8e1',borderRadius:8,padding:'10px 12px',marginTop:10,fontSize:12}}>👉 S'asseoir à l'ombre, boire de l'eau fraîche, humidifier la nuque. Si pas d'amélioration en 15 min → appeler le 15 ET appuyer sur le bouton <strong>"🥵 Je ne me sens pas bien"</strong>.</div>
      </div>
      <div className="card" style={{padding:'14px 16px',borderLeft:'4px solid var(--dg)'}}>
        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
          <div style={{fontSize:26}}>🚨</div>
          <div>
            <div className="D" style={{fontSize:15,color:'var(--dg)'}}>Coup de chaleur (urgence vitale)</div>
            <div style={{fontSize:11,color:'var(--si)'}}>Appel 15 immédiat — risque vital</div>
          </div>
        </div>
        {["Peau chaude, rouge et SÈCHE (arrêt transpiration)","Température corporelle > 40°C","Confusion, désorientation","Maux de tête très intenses","Perte de conscience possible"].map(s=>(<div key={s} style={{display:'flex',gap:8,fontSize:13,padding:'4px 0',fontWeight:s.includes('SÈCHE')||s.includes('40°')?600:'normal'}}><span style={{color:'var(--dg)',fontWeight:700}}>›</span><span>{s}</span></div>))}
        <div style={{background:'#fde8e8',borderRadius:8,padding:'10px 12px',marginTop:10,fontSize:12,fontWeight:600}}>🚨 APPELER LE 15 IMMÉDIATEMENT — Allonger, refroidir avec eau fraîche (pas glacée). Ne pas donner à boire si la personne est inconsciente.<br/>Appuyez aussi sur <strong>"🥵 Je ne me sens pas bien"</strong> pour alerter Claire et Franck.</div>
        <a href="tel:15" className="btn bor" style={{display:'block',textAlign:'center',marginTop:10,fontSize:14,fontWeight:700,textDecoration:'none'}}>📞 Appeler le 15 (SAMU)</a>
      </div>
    </div>)}
    {sec==='conseils'&&(<div style={{display:'flex',flexDirection:'column',gap:12}}>
      <div className="card" style={{padding:'14px 16px'}}>
        <div className="D" style={{fontSize:14,marginBottom:10}}>💧 Hydratation</div>
        {["3 L d'eau minimum par jour en canicule (1,5 à 2 L en temps normal)","Ne pas attendre d'avoir soif — c'est déjà trop tard","Éviter café, alcool, sodas sucrés (déshydratants)","Eau fraîche, pas glacée (10-15°C idéal)"].map(c=>(<div key={c} style={{display:'flex',gap:8,fontSize:13,padding:'5px 0',borderBottom:'1px solid var(--bg)'}}><span style={{color:'var(--mn)',fontWeight:700}}>✓</span><span>{c}</span></div>))}
      </div>
      <div className="card" style={{padding:'14px 16px'}}>
        <div className="D" style={{fontSize:14,marginBottom:10}}>🌬️ Comportements généraux</div>
        {["Pauses à l'ombre / au frais, surtout entre 12h et 17h","Humidifier la nuque et les poignets avec eau fraîche","Porter des vêtements légers et de couleur claire","Signaler tout malaise immédiatement — ne jamais forcer"].map(c=>(<div key={c} style={{display:'flex',gap:8,fontSize:13,padding:'5px 0',borderBottom:'1px solid var(--bg)'}}><span style={{color:'var(--mn)',fontWeight:700}}>✓</span><span>{c}</span></div>))}
      </div>
      <div className="card" style={{padding:'14px 16px',borderLeft:'3px solid #2196F3'}}>
        <div className="D" style={{fontSize:14,marginBottom:10}}>🏠 Pendant le travail dans les appartements</div>
        {[
          "Avec climatisation : fermer les fenêtres et baisser les volets dès l'arrivée — l'air extérieur, souvent à 35°C ou plus l'après-midi, annule l'effet de la clim et fatigue le moteur pour rien",
          "Sans climatisation : ouvrir en grand pour créer un courant d'air — seulement si l'air extérieur n'est pas plus chaud qu'à l'intérieur (souvent le cas le matin, plus rarement l'après-midi)",
          "Commencer par les pièces les plus fraîches (nord, salle de bain)",
          "Faire des pauses courtes dans les pièces climatisées ou le couloir",
          "Produits ménagers : dégagent plus de vapeurs par forte chaleur — si les fenêtres sont ouvertes, aérer encore davantage",
          "N'hésitez pas à prendre une douche rapide ou à vous rafraîchir si vous en ressentez le besoin"
        ].map(c=>(<div key={c} style={{display:'flex',gap:8,fontSize:13,padding:'5px 0',borderBottom:'1px solid var(--bg)',fontWeight:c.includes('hésitez')?600:'normal'}}><span style={{color:'#2196F3',fontWeight:700}}>✓</span><span>{c}</span></div>))}
      </div>
      <div className="card" style={{padding:'14px 16px',borderLeft:'3px solid #FF9800'}}>
        <div className="D" style={{fontSize:14,marginBottom:10}}>☀️ Entre deux appartements</div>
        {[
          "Porter une casquette ou un chapeau — obligatoire par forte chaleur",
          "Appliquer de la crème solaire avant de sortir",
          "Rester à l'ombre autant que possible lors des trajets",
          "Boire un verre d'eau avant de repartir",
          "Un brumisateur dans le sac, ça change tout",
          "Éviter de s'exposer au soleil direct entre 12h et 17h"
        ].map(c=>(<div key={c} style={{display:'flex',gap:8,fontSize:13,padding:'5px 0',borderBottom:'1px solid var(--bg)'}}><span style={{color:'#FF9800',fontWeight:700}}>✓</span><span>{c}</span></div>))}
      </div>
      <div className="card" style={{padding:'14px 16px',borderLeft:'3px solid var(--mn)'}}>
        <div className="D" style={{fontSize:14,marginBottom:10}}>🌙 Après le travail — bien récupérer</div>
        {[
          "Prendre une douche fraîche (pas glacée) dès que possible",
          "Continuer à s'hydrater — la récupération dure plusieurs heures",
          "S'installer dans la pièce la plus fraîche de chez soi",
          "Aérer la nuit quand il fait < 25°C dehors, fermer le jour",
          "Éviter l'alcool le soir (déshydratant, aggrave la fatigue thermique)",
          "Si tu te sens mal le lendemain matin, préviens Claire ou Franck avant de partir"
        ].map(c=>(<div key={c} style={{display:'flex',gap:8,fontSize:13,padding:'5px 0',borderBottom:'1px solid var(--bg)'}}><span style={{color:'var(--mn)',fontWeight:700}}>✓</span><span>{c}</span></div>))}
      </div>
      <div style={{background:'#e8f5e9',border:'1.5px solid var(--mn)',borderRadius:12,padding:'14px 16px',fontSize:12}}>
        <div style={{fontWeight:700,marginBottom:4}}>En cas de doute ou malaise</div>
        Utilisez le bouton <strong>"🥵 Je ne me sens pas bien"</strong> en bas à droite — Claire et Franck sont alertés immédiatement.
      </div>
    </div>)}
  </div>);
}

// Hook partagé : reflète si le pilotage canicule est réellement actif côté admin
// (canicule7.niveau défini et ≠ 'vert' — même règle que CaniBandeau). Sert à
// masquer l'onglet 🌡️ Canicule + le rappel hydratation auto quand le module est
// désactivé ('Non activé' dans CaniPilotage), ce qu'aucun des deux ne faisait avant.
function useCaniculeActif(){
  const[actif,setActif]=useState(false);
  useEffect(()=>{
    const load=()=>supaGet('canicule7').then(d=>setActif(!!(d&&d.niveau&&d.niveau!=='vert'))).catch(()=>{});
    load();
    const id=setInterval(load,300000);
    return()=>clearInterval(id);
  },[]);
  return actif;
}

export { AlerteSanteButton, CaniBandeau, CaniHydrationBanner, CaniTab, useCaniculeActif };
